/* import __COLOCATED_TEMPLATE__ from './copilot.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import safeWindowOpen from 'embercom/lib/safe-window-open';

const ZENDESK_COPILOT_APP_ID = '1123527';
const INSTALL_LINK = `https://www.zendesk.com/marketplace/apps/support/${ZENDESK_COPILOT_APP_ID}`;

interface Args {}

export default class ZendeskCopilot extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: AppService;
  @service declare intercomEventService: $TSFixMe;

  @tracked openSection?: string;

  get zendeskConfiguration() {
    return this.finStandaloneService.zendeskConfig;
  }

  get copilotSeatCount() {
    return this.appService.app.humanAdminsWithCopilotSeat.length;
  }

  @action setSection(section: string) {
    this.openSection = section;
  }

  @action openInstallLink() {
    safeWindowOpen(INSTALL_LINK);
  }

  @action triggerRequestPreviewLinkWorkflow() {
    this.intercomEventService.trackEvent('standalone-zendesk-copilot-request-preview-link', {
      zendesk_subdomain: this.zendeskConfiguration!.subdomain,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Copilot': typeof ZendeskCopilot;
  }
}
